// extracted by mini-css-extract-plugin
export var carrierIcon = "_yd-0";
export var carrierLogo = "_yd-1";
export var detailsSection = "_yd-2";